import { HeroContentLayout } from "./HeroContentLayout";

export const HeroContentSkeleton = () => {
    return (
        <HeroContentLayout
            subtitles={Array.from({ length: 3 }, (_, index) => (
                <span key={`pm-skeleton-subtitle-${index}`} className="ch"></span>
            ))}
            title={<span className="ch" />}
            items={Array.from({ length: 2 }, (_, index) => (
                <span key={`pm-skeleton-value-${index}`} className="ch"></span>
            ))}
            button={<span className="ch" />}
        />
    );
};
